"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _instance = _interopRequireDefault(require("./instance"));
/**
 * Utilities for working with a registry that holds instances of APIs.
 * @module APIRegistry
 */
class APIUtilsRegistry {
  constructor() {
    this._instances = {};
    this.create();
  }

  /**
   * Creates a named instance of APIUtils.
   * @static
   * @function create
   * @param {String} name - The name used to reference this instance when retrieving it from the registry.
   * @param {Object} config - The configuration object. See <a href="module-APIUtils.html#.init">APIUtils.init()</a>.
   * @example
   * APIRegistry.create({
   *     name: 'services',
   *     config: {
   *         baseUrl: 'api/v1'
   *     }
   * });
   * @returns {AxiosInstance} - The axios instance.
   */
  create({
    name = 'default',
    config
  } = {}) {
    if (this._instances[name]) {
      throw new Error(`An instance with the name ${name} already exists. Use APIRegistry.get('${name}') to retrieve it.`);
    }
    this._instances[name] = new _instance.default(config);
    return this._instances[name];
  }

  /**
   * Retrieves the specified instance from the registry.
   * @static
   * @function get
   * @param {String} name - The name of the instance to retrieve.
   * @example
   * const serviceInstance = APIRegistry.get('services');
   * @returns {AxiosInstance} - The axios instance.
   */
  get(name) {
    return this._instances[name];
  }
}
var _default = exports.default = APIUtilsRegistry;